export const Messages = {
  empty: () => ({ type: false, text: '' }),
  success: (text) => ({ type: 'success', text }),
  error: (text) => ({ type: 'error', text }),
  info: (text) => ({ type: 'info', text }),
};
/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

/* AUTH */
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS =
  'MENU_CHANGE_HAS_SUB_ITEM_STATUS';

/* DATA - Collections */
export const GET_COLLECTIONS = 'GET_COLLECTIONS';
export const GET_COLLECTIONS_SUCCESS = 'GET_COLLECTIONS_SUCCESS';
export const GET_COLLECTIONS_ERROR = 'GET_COLLECTIONS_ERROR';
export const CREATE_COLLECTION = 'CREATE_COLLECTION';
export const CREATE_COLLECTION_SUCCESS = 'CREATE_COLLECTION_SUCCESS';
export const CREATE_COLLECTION_ERROR = 'CREATE_COLLECTION_ERROR';
export const UPDATE_COLLECTION = 'UPDATE_COLLECTION';
export const UPDATE_COLLECTION_SUCCESS = 'UPDATE_COLLECTION_SUCCESS';
export const UPDATE_COLLECTION_ERROR = 'UPDATE_COLLECTION_ERROR';
export const DELETE_COLLECTION = 'DELETE_COLLECTION';
export const DELETE_COLLECTION_SUCCESS = 'DELETE_COLLECTION_SUCCESS';
export const DELETE_COLLECTION_ERROR = 'DELETE_COLLECTION_ERROR';

export const SET_CREATING_COLLECTION = 'SET_CREATING_COLLECTION';
export const SET_EDITING_COLLECTION = 'SET_EDITING_COLLECTION';
export const SET_DELETING_COLLECTION = 'SET_DELETING_COLLECTION';

export const INSPECT_COLLECTION = 'INSPECT_COLLECTION';

/* DATA - Layers */
export const GET_LAYERS = 'GET_LAYERS';
export const GET_LAYERS_SUCCESS = 'GET_LAYERS_SUCCESS';
export const GET_LAYERS_ERROR = 'GET_LAYERS_ERROR';
export const CREATE_LAYER = 'CREATE_LAYER';
export const CREATE_LAYER_SUCCESS = 'CREATE_LAYER_SUCCESS';
export const CREATE_LAYER_ERROR = 'CREATE_LAYER_ERROR';
export const UPDATE_LAYER = 'UPDATE_LAYER';
export const UPDATE_LAYER_SUCCESS = 'UPDATE_LAYER_SUCCESS';
export const UPDATE_LAYER_ERROR = 'UPDATE_LAYER_ERROR';

export const UPDATE_LAYER_LIST = 'UPDATE_LAYER_LIST';
export const UPDATE_LAYER_LIST_SUCCESS = 'UPDATE_LAYER_LIST_SUCCESS';
export const UPDATE_LAYER_LIST_ERROR = 'UPDATE_LAYER_LIST_ERROR';
export const SET_ORDER_LAYER_MODAL = 'SET_ORDER_LAYER_MODAL';

export const DELETE_LAYER = 'DELETE_LAYER';
export const DELETE_LAYER_SUCCESS = 'DELETE_LAYER_SUCCESS';
export const DELETE_LAYER_ERROR = 'DELETE_LAYER_ERROR';
export const SET_CURRENT_LAYER = 'SET_CURRENT_LAYER';
export const SET_CURRENT_TRAIT = 'SET_CURRENT_TRAIT';
export const UPDATE_TRAIT = 'UPDATE_TRAIT';
export const UPDATE_TRAIT_SUCCESS = 'UPDATE_TRAIT_SUCCESS';
export const UPDATE_TRAIT_ERROR = 'UPDATE_TRAIT_ERROR';

export const SET_CREATING_LAYER = 'SET_CREATING_LAYER';
export const SET_EDITING_LAYER = 'SET_EDITING_LAYER';
export const SET_DELETING_LAYER = 'SET_DELETING_LAYER';

/* DATA - Traits */
export const CREATE_TRAIT = 'CREATE_TRAIT';
export const CREATE_TRAIT_SUCCESS = 'CREATE_TRAIT_SUCCESS';
export const CREATE_TRAIT_ERROR = 'CREATE_TRAIT_ERROR';

export const DELETE_TRAIT = 'DELETE_TRAIT';
export const DELETE_TRAIT_SUCCESS = 'DELETE_TRAIT_SUCCESS';
export const DELETE_TRAIT_ERROR = 'DELETE_TRAIT_ERROR';

export const SET_CREATING_TRAIT = 'SET_CREATING_TRAIT';
export const SET_EDITING_TRAIT = 'SET_EDITING_TRAIT';
export const SET_DELETING_TRAIT = 'SET_DELETING_TRAIT';

export const SET_PROC_LIST = 'SET_PROC_LIST';
export const ADD_PROCESS = 'ADD_PROCESS';
export const UPDATE_PROCESS = 'UPDATE_PROCESS';
export const DELETE_PROCESS = 'DELETE_PROCESS';
export const PROCS_LOADING = 'PROCS_LOADING';
